import React, { useState, useEffect, useRef, useCallback } from "react";
import { producaov2 as api } from "../../../../../services/apis";
import { isAuthAdmin } from "../../../../../services/auth";
import { Icon, Button, Loader, Dropdown } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  SemanticTable,
  ContainerInputSearch,
  Input,
  ButtonsContainer,
} from "./styles";
import swal from "sweetalert";
import { withRouter, Link } from "react-router-dom";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";
import { systemLogs } from "../../../../../services/system_logs";
import { useDebounce } from "../../../../../hooks/useDebounce";
import { useRouter } from "../../../../../hooks/router";

const activeDropdownValues = [
  {
    key: 'all',
    text: 'Todos',
    value: 'all'
  },
  {
    key: 'active',
    text: 'Ativos',
    value: 'S'
  },
  {
    key: 'inactive',
    text: 'Inativos',
    value: 'N'
  },
]

const ListarConteudo = (props) => {
  const [cursos, setCursos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [searchCount, setSearchCount] = useState(0);
  const [courseState, setCourseState] = useState('all');
  const [page, setPage] = useState(1);

  const { query: { search: querySearch } } = useRouter();

  useEffect(() => {
    let isMounted = true;

    const getCourses = async () => {
      setLoading(true)

      try {
        const params = {
          search,
          page,
          ...(courseState !== 'all' && {ativo: courseState})
        };
  
        const response = await api.get("curso?disableCache=true", { params });

        if(!isMounted) return;

        let logs = { local: "curso/conteudo", texto: `listou os cursos` };
        api.post("system_logs", { acao: JSON.stringify(logs) });

        const newTreinamentos = response.data.map(course => {
          return {
            id: course.id,
            id_treinamento: course.id_treinamento,
            nome: course.curso,
            ativo: course.ativo
          }
        });

        setCursos(newTreinamentos);
        setLoading(false);

      } catch(error) {
        if(!isMounted) return;

        swal("Não foi possível carregar os Cursos", error?.message, "error");
        setLoading(false);
      } finally {
        if(!isMounted) return;
        
        setLoading(false);
      }
    }

    getCourses();

    return () => { isMounted = false }
  }, [page, searchCount, courseState]);

  useEffect(() => {
    if(!search && querySearch) {
      setSearchCount(1);
      setSearch(querySearch);
    }
  }, [querySearch])

  const TreinamentoCopy = useCallback(
    async (id) => {
      try {
        setLoading(true);

        const { treinamento } = (
          await api.post(`/admin/treinamentos/${id}/copy`,{
            headers: {
              access_token: `voitto-token ${localStorage.getItem(
                'oauth_token'
              )}`
            }
          })
        ).data;

        location.reload();
      } catch (err) {
        console.error(err);

        swal("Erro !", "Não foi possível encontrar esse treinamento", "error");
        setLoading(false);
      }
    },
    [cursos]
  );

  const removeCourse = useCallback(
    async (courseID) => {
      try {
        const userResponse = await swal(
          "Remoção de Curso",
          "Você tem certeza que quer remover? ",
          ""
        ).catch(() => false);

        if (!userResponse) {
          return;
        }

        setLoading(true);

        await api.delete(`/admin/curso/${courseID}?needDeleteTreinamento=true`,{
          headers: {
            access_token: `voitto-token ${localStorage.getItem(
              'oauth_token'
            )}`
          }
        });

        await systemLogs(
          "curso/conteudo",
          `deletou o curso e treinamento de ID Curso ${courseID}`
        );

        location.reload();

      } catch (err) {
        console.error(err);
        swal("Ops!", "Houve um erro ao excluir esse treinamento.", "error");
        setLoading(false);
      }
    },
    [cursos]
  );

  const handleChangeSearch = (search) => {
    setSearch(search);
  }

  const handleSearchSubmit = (e) => {
    e?.preventDefault();

    setPage(1);
    setSearchCount(prev => prev + 1);
  }

  const handleActiveChange = (e, selecteState) => {
    setCourseState(selecteState.value);
  }

  const statusMapper = {
    S: 'Ativo',
    1: 'Ativo',
    N: 'Inativo',
    0: 'Inativo'
  }

  return (
    <>
      <Container>
        <AdminMenu />
        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <Content>
            <Title>Cursos</Title>
            <ContainerInputSearch onSubmit={handleSearchSubmit}>
              <Input
                type="text"
                placeholder="Pesquise pelo titulo"
                value={search}
                onChange={(e) => handleChangeSearch(e.target.value)}
              />
              <Dropdown
                selection
                options={activeDropdownValues}
                onChange={handleActiveChange}
                value={courseState}
              />
              <Button type="submit">
                Buscar
              </Button>
              {/* <Link to="/admin/cursos/conteudo/criar">
                <Button>Criar</Button>
              </Link> */}
            </ContainerInputSearch>
            <SemanticTable size="big" celled>
              <SemanticTable.Header>
                <SemanticTable.Row>
                  <SemanticTable.HeaderCell style={{ width: "5%" }}>
                    ID
                  </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell style={{ width: "60%" }}>
                    Titulo
                  </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell style={{ width: "10%" }}>
                    Status
                  </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell style={{ width: "25%" }}>
                    Ações
                  </SemanticTable.HeaderCell>
                </SemanticTable.Row>
              </SemanticTable.Header>
              {cursos.length > 0 ? (
                <SemanticTable.Body>
                  {cursos
                    .map((curso, index) => (
                      <SemanticTable.Row>
                        <SemanticTable.Cell>
                          {curso.id}
                        </SemanticTable.Cell>
                        <SemanticTable.Cell>
                          {curso.nome}
                        </SemanticTable.Cell>
                        <SemanticTable.Cell>
                          {statusMapper[curso.ativo]}
                        </SemanticTable.Cell>
                        <SemanticTable.Cell>
                          <>
                            <Button
                              icon="copy icon"
                              title="Duplicar Curso"
                              size="small"
                              color={"grey "}
                              onClick={() => TreinamentoCopy(curso.id_treinamento)}
                            />
                            <Button
                              icon="edit icon"
                              title="Editar Página de vendas"
                              size="small"
                              color={"blue"}
                              disabled={!curso?.id_treinamento}
                              onClick={() =>
                                window.open(
                                  `/admin/cursos/conteudo/detalhes/${curso.id_treinamento}`
                                )
                              }
                            />
                            <Button
                                icon="discourse icon"
                                title="Curso"
                                size="small"
                                color={"orange"}
                                onClick={() =>
                                  window.open(
                                    `/admin/cursos/detalhes/${curso.id}`
                                  )
                                }
                              />
                              <Button
                                icon="step forward icon"
                                title="Editar Módulos"
                                size="small"
                                color={"green"}
                                onClick={() =>
                                  window.open(
                                    `/admin/ead/cursos/${curso.id}/modulos/`
                                  )
                                }
                              />
                              <Button
                                icon="trash icon"
                                title="Apagar Página de vendas"
                                size="small"
                                color={"red "}
                                onClick={() => removeCourse(curso.id)}
                              />
                          </>
                        </SemanticTable.Cell>
                      </SemanticTable.Row>
                    ))}
                </SemanticTable.Body>
              ) : (
                <h3>Nenhum Curso encontrado</h3>
              )}
            </SemanticTable>
            <ButtonsContainer>
              <Button disabled={page === 1} onClick={() => setPage(prev => prev - 1)}>Página anterior</Button>
              <Button onClick={() => setPage(prev => prev + 1)}>Próxima página</Button>
            </ButtonsContainer>
          </Content>
        )}
      </Container>
    </>
  );
};

export default withRouter(ListarConteudo);
